import React, { useContext } from "react";

const Ctx = React.createContext({
  unitSize: 100,
  width: 100,
  height: 100,
  h: 1,
});

export const WidgetLayoutProvider = Ctx.Provider;

export const useWidgetLayout = () => useContext(Ctx);
